import { faunaAPI } from "../fauna-api";

export const getCostCentres = async () => faunaAPI.callFunction('get_all_CostCentres')
export const createCostCentre = async payload => faunaAPI.callFunction('create_CostCentre', payload)
export const updateCostCentre = async (id, payload) => faunaAPI.callFunction('update_CostCentre', [id, payload])
export const getAllSpendingByCostCentre = async payload => faunaAPI.callFunction('get_all_spending_by_CostCentre', payload)